require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-ai-and-automation-reducing-donor-churn-and-maintaining-sponsor-interest.json") })
        }
      }, "path---blog-ai-and-automation-reducing-donor-churn-and-maintaining-sponsor-interest");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-ai-and-automation-reducing-donor-churn-and-maintaining-sponsor-interest!./.cache/json/blog-ai-and-automation-reducing-donor-churn-and-maintaining-sponsor-interest.json
// module id = 807
// module chunks = 231608221292675